import React from 'react';

const PageTitle = ({ title, subtitle }) => {
    return (
        <section className="backlight-bottom">
            <div className="stg-row">
                <div className="stg-col-6 stg-offset-3 align-center stg-tp-col-10 stg-tp-offset-1">
                    <h1 className="infocolors-page-title" data-appear="fade-up" data-unload="fade-up">{title}</h1>
                    <p className="infocolors-large-text" data-split-appear="fade-up" data-split-unload="fade-up" data-delay="100">{subtitle}</p>
                </div>
            </div>
        </section>
    );
};

export default PageTitle;
